import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import WelcomeToBlueElegance from "./sections/WelcomeToBlueElegance";
import PeaceOfMind from "./sections/PeaceOfMind";
import TheComfortsOfHome from "./sections/TheComfortsOfHome";
import HeartOfOurHome from "./sections/HeartOfOurHome";
import Caregiver from "./sections/Caregiver";
import VoicesOfHowardCounty from "./sections/VoicesOfHowardCounty";
import ScheduleATour from "./sections/ScheduleATour";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <WelcomeToBlueElegance />
      <PeaceOfMind />
      <TheComfortsOfHome />
      <HeartOfOurHome />
      <Caregiver />
      <VoicesOfHowardCounty />
      <ScheduleATour />
      <Contact />
      <Footer />
    </div>;
}